import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Code, Mail, Users, Globe, Github, Linkedin, MessageSquare, Menu, X } from 'lucide-react';
import "./Contact.css";



const Contact = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: '', // Added phone field
  });
  

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Send data to backend if user is logged in
    try {
      const response = await fetch('https://codespirit.onrender.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Thank you for reaching out! We will get back to you soon.');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',
          phone: '',
        });
      } else {
        alert('There was an issue with your submission. Please try again later.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error submitting the form. Please try again later.');
    }
  };

  return (
    <div className="contact-us-page">
<nav className="bg-white shadow-sm relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center">
              <div className="flex items-center">
                <Code className="h-10 w-10 text-indigo-600" />
                <span className="ml-2 text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 text-transparent bg-clip-text">
                  CodeSpirit
                </span>
              </div>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-indigo-600 font-medium">Home</a>
              <a href="/coming-soon" className="text-gray-700 hover:text-indigo-600 font-medium">Hackathons</a>
              <a href="/contact" className="text-gray-700 hover:text-indigo-600 font-medium">Contact Us</a>
              <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">
                Join Now
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-indigo-600 focus:outline-none"
              >
                {isMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                <a
                  href="/"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Home
                </a>
                <a
                  href="/coming-soon"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Hackathons
                </a>
                <a
                  href="/contact"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Contact Us
                </a>
                <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">
                Join Now
              </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <div className="hero-section">
        <h1>Get in Touch with CodeSpirit!</h1>
        <p>We're here to answer all your queries. Let’s collaborate and innovate together!</p>
      </div>

      {/* Contact Form Section */}
      <div className="form-section">
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Your Name"
            required
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Your Email"
            required
          />
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleInputChange}
            placeholder="Subject"
            required
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            placeholder="Your Message"
            rows="5"
            required
          ></textarea>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            placeholder="Your Phone (Optional)"
          />
          <button type="submit" className="submit-btn">Send Message</button>
        </form>
      </div>

 {/* Footer */}
 <footer className="bg-gray-900">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center">
                <Code className="h-8 w-8 text-white" />
                <span className="ml-2 text-xl font-bold text-white">CodeSpirit</span>
              </div>
              <p className="mt-4 text-gray-400">
                Building the future of tech communities, one hackathon at a time.
              </p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">About Us</a></li>
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Events</a></li>
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Community</a></li>
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Contact</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-6">Connect With Us</h3>
                           <div className="space-y-4">
                             <a href="https://whatsapp.com/channel/0029VapOKPqHAdNXNTwL2I1M" className="flex items-center text-gray-400 hover:text-white">
                               <MessageSquare className="h-6 w-6 mr-3" />
                               <span>Join our WhatsApp Channel</span> 
                             </a>
                             <a href="https://www.linkedin.com/company/codespirit" className="flex items-center text-gray-400 hover:text-white">
                               <Linkedin className="h-6 w-6 mr-3" />
                               <span>Follow us on LinkedIn</span> 
                             </a>
                             <a href="mailto:contact@codespirit.in" className="flex items-center text-gray-400 hover:text-white">
                               <Mail className="h-6 w-6 mr-3" />
                               <span>contact@codespirit.in</span> 
                             </a>
                             <a href="#" className="flex items-center text-gray-400 hover:text-white">
                               <Github className="h-6 w-6 mr-3" />
                               <span>Check our GitHub</span> 
                             </a>
                           </div>
            </div>
          </div>
          <div className="mt-8 border-t border-gray-800 pt-8">
            <p className="text-gray-400 text-center">
              © 2025 <a href="/" className="items-center hover:text-white">
                               <span className='text-blue-600' >CodeSpirit</span> 
                             </a> All rights reserved.
            </p>
          </div>
        </div>
      </footer>
     
    </div>
  );
};

export default Contact;